import React, { Component } from 'react';
import { 
  ChevronIcon, 
  ArrowIcon,
  SearchIcon 
} from './SVGIcons';

import GoogleTranslateElement from './googleTranslateElement'
import CatalogBtn from './CatalogBtn'
import Social from './Social'
import SearchForm from './SearchForm'

class App extends Component {
  state = {
    show_gt: false,
    showSearch: false,
    isVideoModalOpen: false,
    isScrolled: false // Добавляем состояние для отслеживания скролла
  }

  componentDidMount() {
    this.setState({
      show_gt: window.innerWidth >= 1200
    })
    
    // Закрытие поиска при клике вне области
    document.addEventListener('mousedown', this.handleClickOutside);
    
    // Добавляем обработчик скролла
    window.addEventListener('scroll', this.handleScroll);
    
    // Проверяем начальную позицию скролла
    this.handleScroll();
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll = () => {
    const scrollPosition = window.scrollY;
    const isScrolled = scrollPosition >= 80;
    
    if (isScrolled !== this.state.isScrolled) {
      this.setState({ isScrolled });
    }
  }

  handleClickOutside = (event) => {
    if (this.searchRef && !this.searchRef.contains(event.target)) {
      this.setState({ showSearch: false });
    }
  }

  toggleSearch = () => {
    this.setState(prevState => ({
      showSearch: !prevState.showSearch
    }));
  }

  handleSearchSubmit = (searchQuery) => {
    // Перенаправление на страницу поиска
    window.location.href = `/search?find=${encodeURIComponent(searchQuery)}`;
  }

  openVideoModal = () => {
    this.setState({ isVideoModalOpen: true });
  };

  closeVideoModal = () => {
    this.setState({ isVideoModalOpen: false });
  };

  render() {
    const { data, showMenu, showWindow } = this.props;
    const topmenu = data?.topmenu || [];
    const market = data?.market || [];
    const { show_gt, showSearch, isVideoModalOpen, isScrolled } = this.state

    return (
      <>
        {/* Модальное окно с видео */}
        {isVideoModalOpen && (
          <div 
            className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm"
            onClick={this.closeVideoModal}
          >
            <div 
              className="relative w-full max-w-4xl bg-black rounded-xl overflow-hidden"
              onClick={(e) => e.stopPropagation()}
            >
              {/* Кнопка закрытия */}
              <button 
                onClick={this.closeVideoModal}
                className="absolute top-4 right-4 z-10 w-10 h-10 rounded-full bg-black/50 hover:bg-black/70 flex items-center justify-center transition-colors duration-200"
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M18 6L6 18M6 6L18 18" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
              {/* Видео iframe */}
              <div className="relative pt-[56.25%]">
                <iframe
                  src="https://rutube.ru/play/embed/027edefefe1734c93179e3b8fc8f4a59/"
                  className="absolute top-0 left-0 w-full h-full"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  webkitAllowFullScreen mozallowfullscreen
                  title="Rutube video player"
                  width="896" height="504"
                />
              </div>
            </div>
          </div>
        )}

        {/* Мобильная версия меню */}
        <div className='fixed top-0 w-full font-medium z-[20] backdrop-blur-2xl xl:hidden'>
          <div className='container'>
            <div className='flex items-center justify-between text-[14px] tracking-[-0.04em] gap-[10px] h-[55px]'>
              <div className='flex items-center justify-center gap-[10px]'>
                <a href="/">
                  <img src={data?.logo} alt='logo' width={186} height={48} className='flex-none hide-ru' />
                  <img src={data?.enlogo} alt='logo' width={186} height={48} className='flex-none hide-en' />
                </a>
                {/* Кнопка с уменьшенным шрифтом для мобильной версии */}
                <button
                  onClick={this.openVideoModal}
                  className='flex items-center justify-center gap-[9px] h-[40px] bg-[#009EE3] rounded-full px-[20px] hover:bg-[#0077b3] transition-colors duration-300 whitespace-nowrap'
                >
                  <span className='text-white text-[13px] xl:text-[14px]'>Видео о нас</span>
                  <ArrowIcon />
                </button>
                {/* Блок с маркетплейсами из data.market */}
                <div className='flex items-center gap-[6px]'>
                  {market.map((item, index) => (
                    <a
                      key={index}
                      href={item.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className='hover:opacity-80 transition-opacity'
                    >
                      <img
                        src={item.image}
                        alt={item.name || 'Маркетплейс'}
                        width={20}
                        height={20}
                        className='w-[20px] h-[20px] object-contain'
                      />
                    </a>
                  ))}
                </div>
              </div>
              <div 
                onClick={() => showMenu()} 
                className='w-[40px] h-[40px] rounded-full bg-[#032E41] flex items-center justify-center flex-none cursor-pointer hover:bg-[#044a63] transition-colors duration-300'
              >
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M11.5853 5.53977C12.4911 5.53977 13.2253 4.80551 13.2253 3.89977C13.2253 2.99402 12.4911 2.25977 11.5853 2.25977C10.6796 2.25977 9.94531 2.99402 9.94531 3.89977C9.94531 4.80551 10.6796 5.53977 11.5853 5.53977Z" fill="white"/>
                  <path d="M4.30407 5.53977C5.20981 5.53977 5.94406 4.80551 5.94406 3.89977C5.94406 2.99402 5.20981 2.25977 4.30407 2.25977C3.39832 2.25977 2.66406 2.99402 2.66406 3.89977C2.66406 4.80551 3.39832 5.53977 4.30407 5.53977Z" fill="white"/>
                  <path d="M11.5853 12.8191C12.4911 12.8191 13.2253 12.0848 13.2253 11.1791C13.2253 10.2733 12.4911 9.53906 11.5853 9.53906C10.6796 9.53906 9.94531 10.2733 9.94531 11.1791C9.94531 12.0848 10.6796 12.8191 11.5853 12.8191Z" fill="white"/>
                  <path d="M4.30407 12.8191C5.20981 12.8191 5.94406 12.0848 5.94406 11.1791C5.94406 10.2733 5.20981 9.53906 4.30407 9.53906C3.39832 9.53906 2.66406 10.2733 2.66406 11.1791C2.66406 12.0848 3.39832 12.8191 4.30407 12.8191Z" fill="white"/>
                </svg>
              </div>
            </div>
          </div>
        </div>

        {/* Десктопная версия меню с эффектом скролла */}
        <div 
          className={`
            fixed top-0 w-full font-medium z-[20] hidden xl:block
            transition-all duration-300
            ${isScrolled ? 'bg-white shadow-lg' : 'bg-transparent'}
          `}
          style={{
            top: isScrolled ? '0' : '20px'
          }}
        >
          <div className='container'>
            <div className={`
              flex items-center justify-between text-[14px] tracking-[-0.04em]
              transition-all duration-300
              ${isScrolled ? 'py-2' : ''}
            `}>
              <a href="/" className='hover:opacity-80 transition-opacity duration-300'>
                <img 
                  src={data?.logo} 
                  alt='logo' 
                  width={260} 
                  height={40} 
                  className='flex-none hide-ru' 
                />
                <img 
                  src={data?.enlogo} 
                  alt='logo' 
                  width={260} 
                  height={40} 
                  className='flex-none hide-en' 
                />
              </a>
              <div className={`
                flex items-center gap-[9px] 2xl:gap-[16px] h-[50px] rounded-full p-[5px] 
                transition-all duration-300
                ${isScrolled 
                  ? 'bg-white' 
                  : 'bg-[#001721] bg-opacity-50 backdrop-blur-[12.9px] hover:bg-opacity-70'
                }
              `}>
                <CatalogBtn 
                  className={`
                    h-[40px] px-[11px] 2xl:px-[16px] flex items-center justify-center gap-[6px] rounded-full 
                    transition-colors duration-300 cursor-pointer
                    ${isScrolled 
                      ? 'bg-[#009EE3] hover:bg-[#0077b3] text-white' 
                      : 'bg-[#032E41] hover:bg-[#044a63]'
                    }
                  `} 
                  menu={data?.katalog || []} 
                  href={data?.katalog_link} 
                />

                {/* Кнопка поиска */}
                <div className="relative" ref={ref => this.searchRef = ref}>
                  <button
                    onClick={this.toggleSearch}
                    className={`
                      w-[40px] h-[40px] rounded-full flex items-center justify-center cursor-pointer 
                      transition-all duration-300
                      ${isScrolled 
                        ? 'bg-gray-100 text-gray-700 hover:bg-gray-200' 
                        : 'bg-[#032E41] text-white hover:bg-[#044a63]'
                      }
                    `}
                    aria-label="Поиск"
                  >
                    <SearchIcon />
                  </button>
                  
                  {/* Форма поиска */}
                  {showSearch && (
                    <div className="absolute top-full left-0 mt-2 z-50">
                      <SearchForm 
                        onSearch={this.handleSearchSubmit}
                        onClose={() => this.setState({ showSearch: false })}
                      />
                    </div>
                  )}
                </div>
                
                <div className='flex items-center gap-[5px] 2xl:gap-[10px] 2xl:text-[18px] whitespace-nowrap'>
                  {topmenu.map((item, index) => (
                    <div 
                      key={index}
                      className='relative group whitespace-nowrap'
                    >
                      {item.submenu && item.submenu.length > 0 ? (
                        <>
                          <div className={`flex items-center gap-[5px] cursor-pointer
                          ${isScrolled 
                            ? 'text-gray-700 hover:text-[#009EE3]' 
                            : 'text-white'
                          }`}>
                            <a 
                              className={`
                                transition-opacity duration-300
                                ${isScrolled 
                                  ? 'opacity-100' 
                                  : 'opacity-60 hover:opacity-100'
                                }
                              `} 
                              href={item.url}
                            >
                              {item.name}
                            </a>
                            <ChevronIcon fill={isScrolled ? '#374151' : 'white'} />
                          </div>
                          
                          <div className={`
                            absolute top-full left-0 mt-2 w-72 rounded-xl py-2 
                            opacity-0 invisible group-hover:opacity-100 group-hover:visible 
                            transition-all duration-300
                            ${isScrolled 
                              ? 'bg-white shadow-lg border border-gray-100' 
                              : 'bg-[#001721] bg-opacity-95 backdrop-blur-[12.9px]'
                            }
                          `}>
                            {item.submenu.map((subItem, subIndex) => (
                              <a
                                key={subIndex}
                                href={subItem.url}
                                className={`
                                  block px-4 py-2 transition-colors duration-300
                                  ${isScrolled 
                                    ? 'text-gray-700 hover:bg-gray-50 hover:text-[#009EE3]' 
                                    : 'text-white opacity-60 hover:opacity-100 hover:bg-[#032E41]'
                                  }
                                `}
                              >
                                {subItem.name}
                              </a>
                            ))}
                          </div>
                        </>
                      ) : (
                        <a 
                          className={`
                            transition-opacity duration-300
                            ${isScrolled 
                              ? 'text-gray-700 hover:text-[#009EE3]' 
                              : 'text-white opacity-60 hover:opacity-100'
                            }
                          `} 
                          href={item.url}
                        >
                          {item.name}
                        </a>
                      )}
                    </div>
                  ))}
                </div>

                {/* Блок с маркетплейсами из data.market */}
                <div className='flex items-center gap-[6px] 2xl:gap-[9px] flex-none'>
                  {market.map((item, index) => (
                    <a 
                      key={index} 
                      href={item.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className='hover:opacity-80 transition-opacity flex-none'
                    >
                      <img
                        src={item.image}
                        alt={item.name || 'Маркетплейс'}
                        width={20}
                        height={20}
                        className='w-[20px] h-[20px] object-contain'
                      />
                    </a>
                  ))}
                </div>

                {show_gt &&
                  <div className={`
                    whitespace-nowrap text-[14px] transition-colors duration-300
                    ${isScrolled ? 'text-gray-500' : 'text-white/60'}
                  `}>
                    <GoogleTranslateElement />
                  </div>
                }  
                
                <div className={`
                  w-[1px] h-[19.5px] transition-colors duration-300
                  ${isScrolled ? 'bg-gray-300' : 'bg-white bg-opacity-20'}
                `} />
                
                <div className='flex items-center gap-[7px]'>
                  <div className='flex flex-col 2xl:flex-row 2xl:text-[18px] gap-[2px]'>
                    <a 
                      href={`tel:${data?.phone?.replace(/[-()\s]/g, '')}`} 
                      className={`
                        me-[7px] whitespace-nowrap transition-colors duration-300
                        ${isScrolled 
                          ? 'text-gray-800 hover:text-[#009EE3]' 
                          : 'text-white hover:text-[#009EE3]'
                        }
                      `}
                    >
                      {data?.phone}
                    </a>
                    <div className='flex gap-[5px]'>
                      <Social social={data?.social || []} width={20} />
                    </div>
                  </div>
                  
                  {/* Кнопка для десктопной версии */}
                  <button
                    onClick={this.openVideoModal}
                    className={`
                      flex items-center justify-center gap-[9px] h-[40px] rounded-full px-[16px] 2xl:px-[25px] 
                      cursor-pointer transition-all duration-300
                      ${isScrolled 
                        ? 'bg-[#009EE3] hover:bg-[#0077b3] text-white shadow-md' 
                        : 'bg-[#009EE3] hover:bg-[#0077b3] text-white'
                      }
                    `}
                  >
                    <span className='text-white'>Видео о нас</span>
                    <ArrowIcon />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }
}

export default App;
